import React from "react";
import PageData from "../../PageData/PageData";
import { useQuery } from "react-query";
import { getAxios } from "../../../../helper/AxiosHelper";
import { ActionButton } from "../../GeneralUI";

const DefaultSeo = () => {
  const fileURL =
    process.env.REACT_APP_FILE_URL;

  const defaultseoColumns = [
    {
      name: "Meta Title",
      selector: (row) => row.meta_title,
      sortable: true,
    },
    {
      name: "Seo Image",
      selector: (row) => row.seo_image,
      cell: (row) => (
        <div className="rounded-circle">
          <img
            className="rounded-circle"
            src={fileURL + "/" + row.seo_image} // Use the image URL from the data
            alt={row.meta_title} // Provide alt text for accessibility
            width={50}
            height={50}
          />
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <ActionButton row={row} pageTitle="defaultseo" />
      ),
    },
  ];
  async function getField() {
    const url = `/admin/defaultseo`;
    try {
      const response = await getAxios(url);
      const fetchedCmsList = response.data;
      return fetchedCmsList.default_seo;
    } catch (error) {
      console.log(error);
    }
  }

  const { data, error, isLoading } = useQuery("DefaultseoList", getField);
  if (isLoading) {
    return <div>Loading......</div>;
  }
  if (error) {
    return <div>Error:{error.message}</div>;
  }

  return (
    <>
      <PageData
        columns={defaultseoColumns}
        tableData={data}
        title="DefaultSeo"
        addRequired={false}
      />
    </>
  );
};

export default DefaultSeo;
